import { Environment } from '@classifieds-sell/environment';

// NOTE: Use test values as default and override for prod in `environment.prod.ts`
// noinspection JSUnusedGlobalSymbols
export const defaultEnvironment: Environment = {
    apiBaseUrlForGringotts: window.location.origin.replace('www', 'api'),
    apiUrl: `${window.location.origin}/property/api`,
    appBaseHref: '/sell/property/',
    authClientId: 'property_direct_sell',
    authScope:
        'openid profile email ' +
        'PropertyCoreApi.Read ' +
        'PropertyCoreApi.Write',
    authUrl: '',
    frontendUrl: `${window.location.origin}/sell/property`,
    name: 'default',
    paymentWidgetUrl: 'https://stable.test.ping.trademe.co.nz',
    production: false,
    tagManagerId: 'GTM-5ZFBB63',
    trademeUrl: `${window.location.origin}`,
    propertyMaintenanceMode: false
};
